module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k98eT"))).then(() => module.bundle.root('dsisd'));